import { WebRoutes } from "consts/enpoints/web";
import type { OnboardingMediaAndComplianceCheck } from "features/ecommerce/types";
import { putOnboardingsMediaComplianceSteps } from "features/ecommerce/api";
import { Merchant } from "ui/forms/ECommerce";
import { useOnboardingForm, useOnboardingStepData } from "ui/organizms/ECommerce/Onboarding/common";
import { useOnboardingApplication } from "../../hooks";

export const useMediaAndComplianceCheck = () => {
    const { getApplicationModel } = useOnboardingApplication();

    const { data } = useOnboardingStepData<OnboardingMediaAndComplianceCheck>();

    const withValues = useOnboardingForm({
        save: putOnboardingsMediaComplianceSteps,
        route: WebRoutes.Onboarding.Merchant,
        getApplicationModel
    });

    const formProps: Merchant.MediaAndComplianceCheck.OnboardingMediaAndComplianceCheckForm = {
        bootstrapData: {},
        initialValues: Merchant.MediaAndComplianceCheck.getInitialValues(data),
        isBootstrapDataLoading: false,
        onSaveOrCreate: async ({
            hasAdverseMediaCoverage,
            adverseMediaCoverageInput,
            hasLegalInvestigation,
            legalInvestigationInput,
            hasCertification,
            isCompliantWithTax,
            isRegisteredWithAuthority,
            registeredWithAuthorityInput
        }, helpers) => (
            withValues({
                hasAdverseMediaCoverage: Number(hasAdverseMediaCoverage),
                adverseMediaCoverageInput,
                hasLegalInvestigation: Number(hasLegalInvestigation),
                legalInvestigationInput,
                hasCertification: Number(hasCertification),
                isCompliantWithTax: Number(isCompliantWithTax),
                isRegisteredWithAuthority: Number(isRegisteredWithAuthority),
                registeredWithAuthorityInput
            }, helpers)
        )
    };

    return {
        ...formProps,
        ...Merchant.MediaAndComplianceCheck.useForm(formProps),
        ...data
    };
};

export default useMediaAndComplianceCheck;
